import { useCoworkerStore } from '@/store';
import { trackEvent } from '@/constants/utils/analytics';
import { reportWorkLaunchError } from '@/lib/reportWorkLaunchError';
import { blockIfWorkModeDisabled } from '@/lib/workModeAvailability';

export function hrefForCreatedWork(created) {
  if (created?.conversationId) return `/c/${created.conversationId}`;
  if (created?.id) return `/coworker/${created.id}`;
  return null;
}

/** Leave the composer. replace avoids losing the race when /app remounts after send. */
export function navigateToCreatedWork(router, created) {
  const href = hrefForCreatedWork(created);
  if (!href || !router) return;
  const go = () => {
    if (typeof router.replace === 'function') router.replace(href);
    else router.push?.(href);
  };
  if (typeof queueMicrotask === 'function') queueMicrotask(go);
  else go();
}

/**
 * Start a new Work thread from a chat prompt (and optional uploaded files),
 * then navigate to it. Used by the while-typing chip (conversation) and the
 * post-response "Send to Work mode" card.
 */
export async function startWorkFromPrompt({
  prompt,
  fileIds = [],
  collectionId,
  agentId,
  router,
  source = 'work_mode_suggestion',
} = {}) {
  const trimmed = String(prompt || '').trim();
  const ids = Array.isArray(fileIds) ? fileIds.filter(Boolean).map(String) : [];
  if (!trimmed && !ids.length) return null;
  if (blockIfWorkModeDisabled()) return null;

  const coworkerState = useCoworkerStore.getState();
  try {
    const created = await coworkerState.createTask({
      prompt: trimmed,
      fileIds: ids,
      ...coworkerState.getComposerLaunchOptions(),
      ...(collectionId ? { collectionId } : {}),
      ...(agentId ? { agentId } : {}),
    });
    trackEvent('work', 'started_from_chat_suggestion', source);
    navigateToCreatedWork(router, created);
    return created;
  } catch (err) {
    reportWorkLaunchError(err, { source });
    return null;
  }
}

export default startWorkFromPrompt;
